export const config = {
  contentful: {
    // S3 URL for navigation space (per-locale file)
    s3Url: 'https://assets.spyscape.net/contentful/k92fldv75np5/en-US.json',
    space: 'k92fldv75np5',
  },
};


/**
 * Current SPYSCAPE venues
 * Used in the Navbar and FlyoutMenu to display ticket links
 * */
export const VENUE_BUTTONS = [
  {
    name: 'New York',
    url: 'https://spyscape.com/tickets-new-york',
  },
  {
    name: 'London',
    url: 'https://spyscape.com/tickets-london',
  },
];
